// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ba9be9e","567":"bc77a154"}[chunkId] + ".chunk.js";
};